import { ScreenFrame } from '@/components/Screen';
import { EntityCard, EntityList } from '@/components/DataList';
import { account } from '@/api/endpoints';
import { errorMessage, pickList } from '@/api/client';
import { useAsync } from '@/hooks/useAsync';
import { Button, Empty, ErrorBox, Loading } from '@/components/ui';
import { str } from '@/utils/format';

export function SessionsScreen() {
  const state = useAsync(
    () => account.sessions(),
    (p) => pickList(p, 'sessions', 'items', 'data'),
  );

  async function revoke(id: unknown) {
    const res = await account.revokeSession({ session_id: id, id });
    if (!res.success) {
      window.alert(errorMessage(res));
      return;
    }
    state.reload();
  }

  if (state.loading) return <Loading />;
  if (state.error) return <ErrorBox message={state.error} onRetry={state.reload} />;

  const list = state.data ?? [];

  return (
    <ScreenFrame mode="customer" title="الجلسات النشطة">
      {list.length === 0 ? (
        <Empty title="لا توجد جلسات" />
      ) : (
        <EntityList>
          {list.map((s, i) => (
            <EntityCard
              key={str(s.id ?? s.session_id, String(i))}
              title={str(s.device_name ?? s.user_agent ?? 'جهاز')}
              meta={`${str(s.ip)} · ${str(s.created_at ?? s.last_seen_at)}`}
              meta2={s.is_current ? 'الجلسة الحالية' : undefined}
              actions={
                s.is_current ? null : (
                  <Button
                    type="button"
                    variant="danger"
                    onClick={() => void revoke(s.id ?? s.session_id)}
                  >
                    إنهاء الجلسة
                  </Button>
                )
              }
            />
          ))}
        </EntityList>
      )}
    </ScreenFrame>
  );
}
